import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section style={{ marginBottom: '2.5rem' }}>
    <h2 style={{
      fontSize: '1.2rem', fontWeight: '600', color: '#00F2FE',
      marginBottom: '1rem', paddingBottom: '0.5rem',
      borderBottom: '1px solid rgba(0, 242, 254, 0.15)',
    }}>
      {title}
    </h2>
    <div style={{ color: 'rgba(255,255,255,0.75)', lineHeight: '1.8', fontSize: '0.95rem' }}>
      {children}
    </div>
  </section>
);

const InfoBox = ({ children, warn }) => (
  <div style={{
    background: warn ? 'rgba(255,200,100,0.07)' : 'rgba(0,242,254,0.04)',
    borderRadius: '10px', padding: '1rem 1.2rem',
    border: warn ? '1px solid rgba(255,200,100,0.2)' : '1px solid rgba(0,242,254,0.08)',
    marginTop: '0.8rem',
  }}>
    {children}
  </div>
);

const BaseLegaleRow = ({ traitement, base, detail }) => (
  <div style={{
    background: 'rgba(0,242,254,0.03)', borderRadius: 8,
    padding: '0.8rem 1rem', border: '1px solid rgba(0,242,254,0.07)',
  }}>
    <p style={{ margin: 0 }}>
      <strong style={{ color: 'rgba(255,255,255,0.9)' }}>{traitement}</strong>
    </p>
    <p style={{ margin: '0.3rem 0 0' }}>
      Base légale :{' '}
      <strong style={{ color: 'rgba(0,242,254,0.9)' }}>{base}</strong>
    </p>
    <p style={{ margin: '0.2rem 0 0', color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem', whiteSpace: 'pre-line' }}>
      {detail}
    </p>
  </div>
);

const ConfidentialitePage = () => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #050B1A 0%, #0A1628 50%, #0F1B3C 100%)',
    padding: '2rem 1rem 4rem',
  }}>
    <div style={{ maxWidth: '760px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '3rem' }}>
        <Link to="/" style={{
          color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem',
          display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
          marginBottom: '2rem', transition: 'color 0.2s',
        }}
          onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
          onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
        >
          ← Retour à l'accueil
        </Link>
        <h1 style={{
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: '700',
          color: 'white', marginBottom: '0.5rem', letterSpacing: '-0.02em',
        }}>
          Politique de confidentialité
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>
          SafeHeir — Dernière mise à jour : Mai 2026
        </p>
      </div>

      <div style={{
        background: 'rgba(10, 22, 40, 0.6)', backdropFilter: 'blur(20px)',
        borderRadius: '20px', padding: '2.5rem',
        border: '1px solid rgba(0, 242, 254, 0.1)',
      }}>

        {/* ── 1. Responsable du traitement ─────────────────────────────── */}
        <Section title="1. Responsable du traitement">
          <p>Le responsable du traitement des données personnelles collectées dans le cadre du service
            SafeHeir est :</p>
          <InfoBox>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Nom :</strong> Azzedi Salemkour</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Statut :</strong> Projet en cours de structuration juridique</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>SIREN :</strong> En cours d'immatriculation</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Adresse :</strong> Gennevilliers, 92230, France</p>
            <p style={{ margin: 0 }}><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Email de contact RGPD :</strong>{' '}
              <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
                contact@safeheir.fr
              </a>
            </p>
          </InfoBox>
        </Section>

        {/* ── 2. Données collectées ─────────────────────────────────────── */}
        <Section title="2. Données collectées">
          <p>Dans le cadre du service, les données suivantes sont traitées :</p>
          <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            {[
              {
                title: 'Compte utilisateur',
                desc: 'Prénom, nom, adresse email, mot de passe (haché de façon irréversible — jamais stocké en clair).',
              },
              {
                title: 'Coffre-fort numérique',
                desc: 'Noms de services, identifiants, URLs — stockés tels quels. Mots de passe et notes — chiffrés (clé dérivée par compte). Ces données sont saisies volontairement par l\'utilisateur.',
              },
              {
                title: 'Bénéficiaires désignés',
                desc: 'Prénom, nom, adresse email, numéro de téléphone et niveau de priorité des bénéficiaires choisis par l\'utilisateur.',
              },
              {
                title: 'Check-in',
                desc: 'Date et heure du dernier check-in, fréquence configurée, délai de grâce, historique des vérifications.',
              },
            ].map(({ title, desc }) => (
              <div key={title} style={{ background: 'rgba(0,242,254,0.04)', borderRadius: '10px', padding: '0.8rem 1rem', border: '1px solid rgba(0,242,254,0.08)' }}>
                <strong style={{ color: 'rgba(255,255,255,0.9)' }}>{title}</strong>
                <p style={{ marginTop: '0.3rem' }}>{desc}</p>
              </div>
            ))}
          </div>
        </Section>

        {/* ── 3. Finalité du traitement ─────────────────────────────────── */}
        <Section title="3. Finalité du traitement">
          <p>Ces données sont collectées <strong style={{ color: 'rgba(255,255,255,0.9)' }}>uniquement</strong> pour :</p>
          <ul style={{ listStyle: 'none', padding: 0, margin: '0.8rem 0 0', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <li>— permettre votre authentification au service ;</li>
            <li>— stocker et afficher vos entrées du coffre-fort ;</li>
            <li>— configurer et, le moment venu, déclencher la transmission à vos bénéficiaires.</li>
          </ul>
          <br />
          <p>Aucune de ces données n'est utilisée à des fins publicitaires, commerciales ou analytiques.</p>
        </Section>

        {/* ── 4. Base légale des traitements (art. 6 RGPD) ─────────────── */}
        <Section title="4. Base légale des traitements (art. 6 RGPD)">
          <p>Conformément à l'article 6 du Règlement Général sur la Protection des Données (RGPD),
            chaque traitement effectué par SafeHeir repose sur une base légale explicite :</p>
          <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <BaseLegaleRow
              traitement="Authentification et gestion du compte"
              base="Exécution du contrat — art. 6.1.b RGPD"
              detail="Le traitement est nécessaire à l'exécution du contrat d'utilisation auquel l'utilisateur est partie (création et accès au compte SafeHeir)."
            />
            <BaseLegaleRow
              traitement="Coffre-fort numérique"
              base="Exécution du contrat — art. 6.1.b RGPD"
              detail="Le stockage chiffré des identifiants et mots de passe constitue la prestation principale du service, indissociable du contrat d'utilisation."
            />
            <BaseLegaleRow
              traitement="Désignation et notification de bénéficiaires"
              base="Exécution du contrat — art. 6.1.b RGPD"
              detail={"La désignation de bénéficiaires est une fonctionnalité essentielle du service SafeHeir : sans elle, aucune transmission ne peut être organisée. Le traitement des données des bénéficiaires (nom, email, téléphone) est donc nécessaire à l'exécution du contrat qui vous lie à SafeHeir.\n\nUne case à cocher obligatoire au moment de la désignation recueille votre engagement à informer chaque personne désignée conformément à l'article 14 du RGPD (information des personnes dont les données sont collectées indirectement). Cet engagement est tracé : horodatage, version du texte affiché, empreinte cryptographique du texte exact.\n\nCe consentement peut être retiré à tout moment en supprimant le bénéficiaire concerné."}
            />
            <BaseLegaleRow
              traitement="Emails de rappel check-in et alertes"
              base="Intérêt légitime — art. 6.1.f RGPD"
              detail="L'envoi de rappels périodiques est nécessaire au bon fonctionnement du mécanisme de protection que l'utilisateur a volontairement activé, dans son propre intérêt et celui de ses bénéficiaires désignés."
            />
          </div>
        </Section>

        {/* ── 5. Stockage des données ───────────────────────────────────── */}
        <Section title="5. Stockage des données">
          <p>Vos données sont hébergées sur l'infrastructure <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Supabase</strong>, serveurs localisés à Stockholm (Suède), au sein de l'Union Européenne. Aucun transfert hors UE n'est effectué pour le stockage de vos données.</p>
          <InfoBox>
            <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Architecture zero-knowledge</strong>
            <p style={{ marginTop: '0.5rem', color: 'rgba(255,255,255,0.75)' }}>
              Vos mots de passe et notes sensibles sont{' '}
              <strong style={{ color: 'rgba(255,255,255,0.95)' }}>
                chiffrés côté client (dans votre navigateur)
              </strong>{' '}
              avant transmission. SafeHeir ne stocke et ne peut lire vos données en clair — pas même en cas d'accès aux serveurs.
            </p>
          </InfoBox>
          <p style={{ marginTop: '0.8rem' }}>
            Les mots de passe et notes du coffre-fort sont chiffrés avec une clé dérivée de votre
            identifiant de compte (AES-256-GCM). Le nom du service, l'identifiant et l'URL ne sont pas chiffrés.
            Le mot de passe de votre compte est haché de façon irréversible et n'est pas récupérable.
          </p>
        </Section>

        {/* ── 6. Accès aux données ─────────────────────────────────────── */}
        <Section title="6. Accès aux données">
          <p><strong style={{ color: 'rgba(255,255,255,0.9)' }}>Seul vous</strong> avez accès à vos
            données. L'architecture zero-knowledge garantit que l'équipe SafeHeir ne peut techniquement
            pas lire vos données sensibles en clair.</p>
          <br />
          <p>Vos bénéficiaires reçoivent uniquement les informations que vous leur avez attribuées,
            au moment où vous l'avez configuré. Ils ne voient pas les entrées du coffre-fort qui ne
            leur sont pas destinées.</p>
        </Section>

        {/* ── 7. Sous-traitants et transferts hors UE ──────────────────── */}
        <Section title="7. Sous-traitants et transferts hors Union Européenne">
          <p>Dans sa version actuelle, SafeHeir recourt au service tiers suivant pour l'envoi d'alertes
            et de rappels email :</p>
          <div style={{ marginTop: '1rem', background: 'rgba(0,242,254,0.04)', borderRadius: '10px', padding: '1rem 1.2rem', border: '1px solid rgba(0,242,254,0.08)' }}>
            <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Brevo (anciennement Sendinblue)</strong>
            <p style={{ marginTop: '0.4rem' }}>
              Prestataire d'envoi d'emails transactionnels —{' '}
              <a href="https://www.brevo.com/fr/legal/privacypolicy/" target="_blank" rel="noopener noreferrer" style={{ color: '#00F2FE', textDecoration: 'none' }}>
                politique de confidentialité Brevo
              </a>.
              Les données transmises lors d'une alerte se limitent au nom et à l'adresse email du
              bénéficiaire concerné, ainsi qu'un message générique. Aucun mot de passe ni contenu du
              coffre-fort n'est transmis.
            </p>
            <p style={{ marginTop: '0.5rem' }}>
              Brevo agit en qualité de{' '}
              <strong style={{ color: 'rgba(255,255,255,0.85)' }}>sous-traitant</strong> au sens de
              l'article 28 du RGPD. Un accord de traitement des données (DPA) encadre cette relation
              conformément aux exigences légales européennes.
            </p>
            <p style={{ marginTop: '0.5rem' }}>
              <strong style={{ color: 'rgba(255,255,255,0.85)' }}>Hébergement Union Européenne :</strong>{' '}
              Brevo SAS est une société française dont les serveurs sont hébergés en Europe.
              Aucun transfert de données hors Union Européenne n'est effectué pour ce service.
            </p>
          </div>
          <p style={{ marginTop: '1rem' }}>
            Aucun autre prestataire tiers ne reçoit vos données dans la version actuelle du service.
          </p>
        </Section>

        {/* ── 8. Durée de conservation ─────────────────────────────────── */}
        <Section title="8. Durée de conservation">
          <p>Vos données sont conservées{' '}
            <strong style={{ color: 'rgba(255,255,255,0.9)' }}>sur les serveurs SafeHeir</strong>{' '}
            tant que vous ne les supprimez pas explicitement.</p>
          <div style={{ marginTop: '0.8rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {[
              ['Données de compte', 'Conservées jusqu\'à suppression du compte depuis Paramètres → Supprimer mon compte, ou effacement du localStorage du navigateur.'],
              ['Données du coffre-fort', 'Conservées jusqu\'à leur suppression individuelle ou la suppression du compte.'],
              ['Données de bénéficiaires', 'Conservées jusqu\'à leur suppression individuelle ou la suppression du compte.'],
              ['Clé de chiffrement du coffre-fort', 'Stockée uniquement en sessionStorage (mémoire de session) ; effacée automatiquement à la fermeture de l\'onglet.'],
            ].map(([label, desc]) => (
              <div key={label}>
                — <strong style={{ color: 'rgba(255,255,255,0.85)' }}>{label}</strong> : {desc}
              </div>
            ))}
          </div>
          <p style={{ marginTop: '0.8rem' }}>
            Lors du passage à une architecture serveur, une politique de rétention explicite sera définie
            (suppression automatique après 24 mois d'inactivité, conformément aux recommandations CNIL).
          </p>
        </Section>

        {/* ── 9. Vos droits (RGPD) ────────────────────────────────────── */}
        <Section title="9. Vos droits (RGPD)">
          <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez
            des droits suivants :</p>
          <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {[
              ['Droit d\'accès', 'Vous pouvez consulter l\'ensemble de vos données directement dans l\'application.'],
              ['Droit de rectification', 'Vous pouvez modifier vos données à tout moment dans les différentes sections de l\'application.'],
              ['Droit à la portabilité (Art. 20)', 'Vous pouvez exporter l\'intégralité de vos données au format JSON depuis Paramètres → Exporter mes données.'],
              ['Droit à l\'effacement (Art. 17)', 'Vous pouvez supprimer définitivement votre compte et toutes les données associées depuis Paramètres → Supprimer mon compte.'],
              ['Droit d\'opposition', 'Vous pouvez cesser d\'utiliser le service à tout moment et supprimer vos données comme décrit ci-dessus.'],
            ].map(([title, desc]) => (
              <div key={title}>
                <strong style={{ color: 'rgba(255,255,255,0.9)' }}>{title}</strong> — {desc}
              </div>
            ))}
          </div>
          <br />
          <p>Pour exercer ces droits ou pour toute question :{' '}
            <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              contact@safeheir.fr
            </a>
          </p>
          <p style={{ marginTop: '0.5rem' }}>
            Vous disposez également du droit de déposer une réclamation auprès de la{' '}
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              Commission Nationale de l'Informatique et des Libertés (CNIL)
            </a>{' '}
            si vous estimez que le traitement de vos données n'est pas conforme à la réglementation.
          </p>
          <InfoBox>
            <p style={{ margin: 0, fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)' }}>
              <strong style={{ color: 'rgba(255,255,255,0.9)' }}>Délégué à la protection des données (DPO) :</strong>{' '}
              SafeHeir ne dispose pas d'un DPO formellement désigné. En application de l'article 37 du RGPD,
              la désignation d'un DPO n'est pas obligatoire pour une structure dont les traitements ne
              constituent pas une activité de base impliquant un suivi régulier et systématique à grande
              échelle. Pour toute question relative à la protection de vos données, contactez directement
              l'éditeur à l'adresse indiquée ci-dessus.
            </p>
          </InfoBox>
        </Section>

        {/* ── 10. Cookies et traceurs ──────────────────────────────────── */}
        <Section title="10. Cookies et traceurs">
          <p>SafeHeir n'utilise <strong style={{ color: 'rgba(255,255,255,0.9)' }}>pas</strong> de cookies
            tiers à des fins de suivi ou de publicité. Le service utilise uniquement le stockage local
            (localStorage et sessionStorage) strictement nécessaire au fonctionnement de l'application
            (authentification, données utilisateur, préférences d'interface).</p>
          <p style={{ marginTop: '0.6rem' }}>
            Ce stockage local fonctionnel ne nécessite pas de consentement préalable au sens de la
            directive ePrivacy, mais fait l'objet d'une information transparente conformément aux
            recommandations de la CNIL.
          </p>
        </Section>

        {/* ── 11. Modifications ────────────────────────────────────────── */}
        <Section title="11. Modifications">
          <p>Cette politique peut être mise à jour pour refléter l'évolution du service, notamment lors
            du passage à une architecture serveur. Toute modification significative sera signalée aux
            utilisateurs connectés. La date de dernière mise à jour est indiquée en en-tête.</p>
        </Section>

        {/* ── 12. Contact ──────────────────────────────────────────────── */}
        <Section title="12. Contact">
          <p>Pour toute question relative à cette politique de confidentialité :{' '}
            <a href="mailto:contact@safeheir.fr" style={{ color: '#00F2FE', textDecoration: 'none' }}>
              contact@safeheir.fr
            </a>
          </p>
        </Section>

      </div>

      {/* Footer navigation */}
      <div style={{ marginTop: '2rem', textAlign: 'center', display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        {[
          { to: '/legal/cgu', label: 'CGU' },
          { to: '/legal/mentions-legales', label: 'Mentions légales' },
          { to: '/faq', label: 'FAQ' },
          { to: '/', label: 'Accueil' },
        ].map(({ to, label }) => (
          <Link key={to} to={to} style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem' }}
            onMouseEnter={(e) => e.target.style.color = '#00F2FE'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
          >
            {label}
          </Link>
        ))}
      </div>

    </div>
  </div>
);

export default ConfidentialitePage;
